import * as Sentry from '@sentry/react'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { configureStore, Tuple } from '@reduxjs/toolkit'
import reducers from 'app-redux/reducers'
import { persistStore } from 'redux-persist'

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const _configureStore = (history) => {
  const routeMiddleware = routerMiddleware(history)

  const store = configureStore({
    reducer: reducers(history),
    middleware: () => new Tuple(thunk, routeMiddleware),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
    devTools: !import.meta.env.PROD, // Redux DevTools otomatis diaktifkan di development
  })

  const persistor = persistStore(store)

  return { store, persistor }
}

export default _configureStore
